/**
 * SPA-friendly auth redirects from non-React modules (e.g. api.ts fetch layer).
 * Registered once from App with react-router navigate to avoid full page reloads.
 */

type NavigateFn = (to: string, opts?: { replace?: boolean }) => void;

let authRedirectHandler: NavigateFn | null = null;

export function registerAuthRedirectHandler(handler: NavigateFn | null): void {
  authRedirectHandler = handler;
}

export function redirectToLogin(): void {
  if (typeof window === 'undefined') return;
  if (authRedirectHandler) {
    try {
      authRedirectHandler('/login', { replace: true });
      return;
    } catch {
      // fall through
    }
  }
  window.location.assign('/login');
}
